"use strict";
var appn;
(function (appn) {
    var dataView;
    (function (dataView) {
        function init() {
            addEvents();
        }
        dataView.init = init;
        function addEvents() {
            $('.btn-toggle-dataview').click(function (e) {
                e.preventDefault();
                const screenKey = $('#SelectedScreenKey').val();
                let version = $('#SelectedVersionNo').val();
                if (!version)
                    version = 0;
                const urlToLoad = $(this).prop('href');
                const url = urlToLoad +
                    '?selectedscreenkey=' + screenKey +
                    '&selectedversionno=' + version;
                window.location.href = url;
            });
            $('#SelectedScreenKey').change(function () {
                $('#SelectedVersionNo').append('<option value="0" selected="selected"></option>');
                $('#EntryId').val(appn.emptyString);
                appn.dialog.showLoading();
                $('form#appnForm').submit();
            });
            $('#SelectedVersionNo').change(function () {
                $('#EntryId').val(appn.emptyString);
                appn.dialog.showLoading();
                $('form#appnForm').submit();
            });
        }
    })(dataView = appn.dataView || (appn.dataView = {}));
})(appn || (appn = {}));
